import React from "react";
import { TextField } from "@mui/material";

const CustomTextField = ({ sx = {}, size = "small", ...props }) => {
  return (
    <TextField
      fullWidth
      size={size}
      {...props}
      sx={{
        "& .MuiInputLabel-root": {
          color: "var(--text-primary)",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "var(--text-primary)",
        },
        "& .MuiOutlinedInput-root": {
          color: "var(--text-primary)",

          "& fieldset": {
            borderColor: "var(--border-color)",
          },

          "&:hover fieldset": {
            borderColor: "var(--border-color)",
          },

          "&.Mui-focused fieldset": {
            borderColor: "var(--text-primary)",
          },

          "& input": {
            color: "var(--text-primary)",
          },

          "& textarea": {
            color: "var(--text-primary)",
          },

          "& input::-webkit-calendar-picker-indicator": {
            filter: "invert(1)",
            cursor: "pointer",
          },
        },

        ...sx,
      }}
    />
  );
};

export default CustomTextField;
